import React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import MoreHorizIcon from '@mui/icons-material/MoreHorizOutlined';
import { NavLink } from 'react-router-dom';
import { NavigationItemType } from 'framework/navigation';
import DropdownMenu from '../../../DropdownMenu';
import { isHeaderMenuItemActive } from '../utils/headerMenuMatching';
import { OVERFLOW_BUTTON_WIDTH } from '../useDesktopHeaderMenuItemsService';

const HeaderMenuOverflow = ({ items, pathname }: { items: NavigationItemType[]; pathname: string }) => (
  <DropdownMenu
    popupId="header-menu"
    iconButton={
      <IconButton
        title="More"
        aria-label="More"
        sx={{ width: OVERFLOW_BUTTON_WIDTH, height: OVERFLOW_BUTTON_WIDTH, flexShrink: 0, alignSelf: 'center' }}
      >
        <MoreHorizIcon />
      </IconButton>
    }
  >
    {items.flatMap(item => {
      const entries = item.thirdLevelMenuChildren || [item];
      return entries.map(child => (
        <NavLink to={child.url} end={child.exact} key={`${item.name}-${child.url}-${child.name}`}>
          <MenuItem
            id={child.url}
            className={`header-menu__hidden-item ${isHeaderMenuItemActive(child, pathname) ? 'active' : ''}`}
            sx={{ color: (theme: any) => theme.vars.palette.text.primary }}
          >
            <Typography>{item.thirdLevelMenuChildren ? `${item.name} / ${child.name}` : child.name}</Typography>
          </MenuItem>
        </NavLink>
      ));
    })}
  </DropdownMenu>
);

export default HeaderMenuOverflow;
